export enum CardGameProviderEnum {
  All = '',
  '789Club' = '789club',
  Techplay = 'techplay',
  Rikvip = 'rikvip',
  B52 = 'b52',
  Go88 = 'go88',
  Playngo = 'playngo',
  JdbGaming = 'jdb',
  Habanero = 'habanero',
  Hitclub = 'hitclub',
  W79 = 'w79',
  Sunwin = 'sunwin',
  Saba = 'saba',
  CQ9 = 'cq9',
  Fachai = 'fachai',
  JILI = 'jili',
  PGSoft = 'pgsoft',
}

export enum GameLobbyEnum {
  All = 'all',
  Slots = 'slots',
  Fishing = 'ban-ca',
  Card = 'game-bai',
  Instant = 'instant',
  Lottery = 'lode',
  Dial = 'quay-so',
  Other = 'other',
}

export enum FishingGameProviderEnum {
  All = '',
  Cq9 = 'cq9',
  Techplay = 'techplay',
  QTech = 'qtech',
  JdbGaming = 'jdb',
  Microgaming = 'microgaming',
  SimplePlay = 'simpleplay',
  Fachai = 'fachai',
  Jili = 'jili',
  Askmebet = 'askmebet',
}

export enum JackpotGameProviderEnum {
  All = '',
  PGSoft = 'pgsoft',
  Techplay = 'techplay',
  Rikvip = 'rikvip',
  JdbGaming = 'jdb',
  Evoplay = 'evoplay',
  Habanero = 'habanero',
  Microgaming = 'microgaming',
  QTech = 'qtech',
  Cq9 = 'cq9',
  RedTiger = 'redtiger',
  Netent = 'netent',
  Pragmaticplay = 'pragmaticplay',
  SimplePlay = 'simpleplay',
  Playngo = 'playngo',
  Fachai = 'fachai',
  Hacksaw = 'hacksaw',
  Jili = 'jili',
  Spinomenal = 'spinomenal',
  Tomhorngaming = 'tomhorn',
  Askmebet = 'askmebet',
  Onegame = 'onegame',
}

export enum InstantGameProviderEnum {
  All = '',
  Spribe = 'spribe',
  Techplay = 'techplay',
  Go88 = 'go88',
  Rikvip = 'rikvip',
  B52 = 'b52',
  QTech = 'qtech',
  Evoplay = 'evoplay',
  Hitclub = 'hitclub',
}

export enum DialGameProviderEnum {
  All = '',
  Techplay = 'techplay',
  Saba = 'saba',
  PragmaticPlay = 'pragmatic',
  Spribe = 'spribe',
  Playngo = 'playngo',
  QTech = 'qtech',
  JdbGaming = 'jdb',
  Jili = 'jili',
  Askmebet = 'askmebet',
}

export enum OtherGameProviderEnum {
  All = '',
  Techplay = 'techplay',
  Spribe = 'spribe',
  Netent = 'netent',
  PragmaticPlay = 'pragmatic',
  QTech = 'qtech',
  Habanero = 'habanero',
  SimplePlay = 'simplePlay',
  CQ9 = 'cq9',
  Fachai = 'fachai',
  JILI = 'jili',
}

export enum LotteryGameProviderEnum {
  All = '',
  Techplay = 'techplay',
  Saba = 'saba',
  Microgaming = 'microgaming',
  JdbGaming = 'jdb',
}

export enum GameGroupEnum {
  Top = 'top',
  Event = 'event',
  TopSlotGame = 'top-no-hu',
  Welcome = 'welcome',
}

export enum CasinoProviderSlugEnum {
  All = 'all',
  Evolution = 'evolution',
  Ebet = 'ebet',
  DGCasino = 'dream-gaming',
  VivoGaming = 'vivo-gaming',
  Ezugi = 'ezugi',
  Pragmatic = 'pragmatic',
  Hogaming = 'hogaming',
  Go88 = 'go88',
  Hitclub = 'hitclub',
  Rikvip = 'rikvip',
  B52 = 'b52',
  Yeebet = 'yeebet',
  Microgaming = 'microgaming',
  Sunwin = 'sunwin',
  '789club' = '789club',
  Jili = 'jili',
  SaGameing = 'sa-gaming',
  ViaGaming = 'via-gaming',
  QTech = 'qtech',
  Playngo = 'playngo',
}

export enum CasinoGroupEnum {
  TopGame = 'top-game',
}

export enum CasinoPlayerType {
  Nanoplayer = 'nanoplayer',
  Millicast = 'millicast',
}

export enum EvolutionCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  Blackjack = 'blackjack',
  Roulette = 'roulette',
  TableGames = 'table-games',
  Sicbo = 'sicbo',
  DragonTiger = 'dragon-tiger',
  FanTan = 'fan-tan',
  CasinoHoldem = 'casino-holdem',
  Poker = 'poker',
  GameShow = 'game-shows',
}

export enum Club789CasinoCategory {
  All = '',
  TaiXiu = 'tai-xiu',
  XocDia = 'xoc-dia'
}

export enum RikvipCasinoCategory {
  All = '',
  TaiXiu = 'tai-xiu',
  XocDia = 'xoc-dia',
  BauCua = 'bau-cua'
}

export enum SunwinCasinoCategory {
  All = '',
  TaiXiu = 'tai-xiu',
  XocDia = 'xoc-dia',
  Sicbo = 'sicbo'
}

export enum ViaGamingCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  Blackjack = 'blackjack',
  Cards = 'cards',
  Roulette = 'roulette',
  AndarBahar = 'andar-bahar',
  Dice = 'dice',
  DragonTiger = 'dragon-tiger',
  Poker = 'poker',
  TeenPatti = 'teen-patti',
  RockPaperScissors = 'rock-paper-scissors',
  XocDia = 'xoc-dia',
}

export enum SaGameingCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  Blackjack = 'blackjack',
  Roulette = 'roulette',
  AndarBahar = 'andar-bahar',
  CardGame = 'card-game',
  DragonTiger = 'dragon-tiger',
  SicBo = 'sicbo',
  XocDia = 'xoc-dia',
  TeenPatti = 'teen-patti',
}

export enum HitclubCasinoCategory {
  All = '',
  TaiXiu = 'tai-xiu',
  XocDia = 'xoc-dia',
  BauCua = 'bau-cua'
}

export enum B52CasinoCategory {
  All = '',
  TaiXiu = 'tai-xiu',
  XocDia = 'xoc-dia',
  BauCua = 'bau-cua'
}

export enum PlayngoCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  TableGames = 'table-games',
  Poker = 'poker',
  Blackjack = 'blackjack',
}

export enum EbetCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  Roulette = 'roulette',
  GameShow = 'game-shows',
  Other = 'other',
}

export enum DGCasinoCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  Roulette = 'roulette',
  Poker = 'poker',
  Sicbo = 'sicbo',
  Other = 'other',
}

export enum VivoGamingCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  Blackjack = 'blackjack',
  Roulette = 'roulette',
  DragonTiger = 'dragon-tiger',
  CasinoHoldem = 'casino-holdem',
}

export enum EzugiCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  Blackjack = 'blackjack',
  Roulette = 'roulette',
  DragonTiger = 'dragon-tiger',
  Sicbo = 'sicbo',
  Poker = 'poker',
  AndarBahar = 'andar-bahar',
  Lucky = 'lucky',
  ThirtyTwoCard = '32-card',
}

export enum PragmaticCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  Blackjack = 'blackjack',
  Roulette = 'roulette',
  GameShow = 'game-shows',
  SuperTrunfo = 'super-trunfo',
  MegaSicBo = 'mega-sicbo',
  DragonTiger = 'dragon-tiger',
}

export enum QTechCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  Blackjack = 'blackjack',
  Roulette = 'roulette',
  BacBo = 'bac-bo',
  DragonTiger = 'dragon-tiger',
}

export enum HogamingCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  Blackjack = 'blackjack',
  Roulette = 'roulette',
  DragonTiger = 'dragon-tiger',
  RNGGames = 'rng-games',
}

export enum YeebetCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  Roulette = 'roulette',
  LiveRoulette = 'live-roulette',
  DragonTiger = 'dragon-tiger',
  Sicbo = 'sicbo',
  SpeedBaccarat = 'speed-baccarat',
  GameShow = 'game-shows',
}

export enum JiliCasinoCategory {
  All = '',
  Casino = 'casino'
}

export enum MicrogamingCasinoCategory {
  All = '',
  Baccarat = 'baccarat',
  Roulette = 'roulette',
  Sicbo = 'sicbo',
}

